"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import { BookOpen, Calendar, Home } from "lucide-react"

const ITEMS = [
  { label: "Início", href: "/", icon: Home, exact: true },
  { label: "Calendário", href: "/calendar", icon: Calendar },
  { label: "Cursos", href: "/courses", icon: BookOpen, exact: true },
]

export function MobileNav() {
  const pathname = usePathname()
  const isFocusPage =
    /^\/learn\/[^/]+\/lesson\/[^/]+$/.test(pathname) ||
    /^\/learn\/simulados\/[^/]+\/tentativa$/.test(pathname)
  if (
    isFocusPage ||
    pathname.startsWith("/admin") ||
    pathname.startsWith("/partners")
  )
    return null

  return (
    <nav
      aria-label="Navegação principal"
      className="fixed right-0 bottom-0 left-0 z-50 border-t border-black/[0.07] bg-white/95 pb-[env(safe-area-inset-bottom)] backdrop-blur lg:hidden"
    >
      <div className="grid h-16 grid-cols-3">
        {ITEMS.map((item) => {
          const active =
            item.href === "/courses"
              ? pathname === "/courses" ||
                /^\/learn\/[^/]+\/(content|challenge)/.test(pathname)
              : item.exact
                ? pathname === item.href
                : pathname.startsWith(item.href)
          const Icon = item.icon
          return (
            <Link
              key={item.href}
              href={item.href}
              aria-current={active ? "page" : undefined}
              className={`flex min-h-11 flex-col items-center justify-center gap-1 text-[10px] font-semibold focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-brand-700 ${active ? "text-brand-700" : "text-ink-muted"}`}
            >
              <Icon className="h-5 w-5" />
              {item.label}
            </Link>
          )
        })}
      </div>
    </nav>
  )
}
